/**
 * @module Store/config
 * @description configuration file for the application
 */
import Vue from 'vue';
import { utils } from '../../plugins/utils';
/**
 * @constant State of config
 * @type {object}
 * @property {string} productServicePort
 * @property {string} templatePort
 * @property {string} orderManagerPort
 * @property {string} priceServicePort
 * @property {string} coldStoragePort
 * @description This constant holds the state of cart
 * */
const state = {
    // eslint-disable-next-line
    productServicePort: '/products',
    templatePort: '/templates',
    orderManagerPort: '/ordermanager',
    priceServicePort: '/prices',
    promotionsServicePort: '/promotion',
    coldStoragePort: '/coldstorage',
    printerManager: '/printmanager',
    auth: '/auth',
    utilities: '/utilities',
    configurator: '/configurator',
};

/**
 * @constant Getters
 * @type {object}
 * @property {function} getConfig - returns config
 * @property {function} getProductPort - returns productServicePort
 * @property {function} getTemplatePort - returns templatePort
 * @property {function} getOrderManagerPort - returns orderManagerPort
 * @property {function} getPriceServicePort - returns priceServicePort
 * @property {function} getColdStoragePort - returns coldStoragePort
 * @description This constant represents the getters for the config store
 * */
const getters = {
    getProductPort: state => state.productServicePort,
    getOrderManagerPort: state => state.orderManagerPort,
    getPriceServicePort: state => state.priceServicePort,
    getColdstoragePort: state => state.coldStoragePort
};

const actions = {
    //eslint-disable-next-line
    createActions ({}, route) {
        return new Promise((resolve) => {
            Vue.axios.get(route).then(res => {
                const routes = res.data;
                if (typeof res.data === 'string') {
                    resolve(false);
                }
                let API = [];
                for (let key in routes) {
                    let routeKey = routes[key];
                    for (let method in routeKey) {
                        let routeDeclaration = routeKey[method];
                        let input = typeof routeDeclaration.input === 'object' ? routeDeclaration.input : null;
                        if (routeDeclaration.handler && routeDeclaration.handler !== 'GetRouteConfig') {
                            let requiresBody = method === 'POST' || method === 'PUT';
                            let action =
                                `${routeDeclaration.handler}: () => {/*${routeDeclaration.description}*/
    return new Promise((resolve, reject) => {
        ${input && requiresBody ? 'const body = ' + JSON.stringify(input) : ''}
        return Vue.axios.${method.toLocaleLowerCase()}('${route}${key}'${requiresBody ? ', body' : ''}).then(res => {
            resolve(res.data); 
        }).catch(err => {
            reject(err);
        });
    });
}`;
                            API.push(action);
                        }
                    }
                }
                resolve(API);
            });
        });
    },
    //eslint-disable-next-line
    async getApiAsync ({state, commit}) {
        const promises = [];
        const routes = [];
        for(let route in state) {
            routes.push(state[route]);
        }
        routes.forEach(route => promises.push(Vue.axios.get(route)));
        try {
            let res = await utils.resolvePromises(promises);
            res = res.map((data, index) => ({name: routes[index], data}));
            return res;
        } catch (err) {
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: 'to get api'
            });
            throw new Error(err);
        }
    }
};

export default {
    state,
    getters,
    actions
};
